import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COMMON } from "@store/theme/common/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import React, { FC } from "react";
import { css } from "styled-components";

export interface RightCornerFloatingWrapperStyles {
    wrapper?: InjectableCss;
}

const wrapperSize = `calc((100vw - (100vw - 100%) - ${COMMON.width.content}px) / 2)`;

export const rightCornerFloatingWrapperStyles: RightCornerFloatingWrapperStyles = {
    wrapper: {
        css: css`
            display: flex;
            position: fixed;
            bottom: 5%;
            right: 0;
            align-items: center;
            width: ${wrapperSize};
            min-width: 190px;
            min-height: 50px;
            z-index: 99;
            pointer-events: none;

            & > div {
                pointer-events: none; /* This is for the CMS zone div */
                & > * {
                    pointer-events: auto; /* This is for any content inside the CMS zone div */
                }
            }

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        { values: ["0 10px", null, null, null, "0"], properties: ["padding"] },
                        { values: ["60px", null, null, "5%", null], properties: ["bottom"] },
                        { values: ["right", null, null, null, "center"], properties: ["text-align"] },
                    ],
                    mediaOptions.min,
                )}
        `,
    },
};

type OwnProps = WidgetProps;

const styles = rightCornerFloatingWrapperStyles;

const RightCornerFloatingWrapper: FC<OwnProps> = ({ id }) => {
    return (
        <>
            <StyledWrapper {...styles.wrapper}>
                <Zone contentId={id} zoneName="Buttons" />
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: RightCornerFloatingWrapper,
    definition: {
        displayName: "Right Corner Floating Wrapper",
        group: "Common",
    },
};

export default widgetModule;
